import styled, { css } from "styled-components";
import Icon from "../../../../../base/icons/icon/index.js";
import Image from "../../../../../base/multimedia/image/index.js";
import { InnerMarkdownHTML } from "../../../../../base/text/inner-markdown-HTML/index.js";
import { BoxShadowWithHover } from "../../../../../../styles/common/mixins/box-shadow.styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import { Border, BorderRadius } from "../../../../../../styles/common/mixins/logical.styled.js";
import { Stars } from "../../../../../../styles/common/mixins/stars.styled.js";
import productCardDesktopThemes from "./themes/index.js";
export const ProductCardBody = styled.main.withConfig({
    displayName: "styled__ProductCardBody",
    componentId: "sc-2abbd9bc-0"
})`
	${({ theme  })=>Border({
        bottom: `1px solid ${theme.border.color.light}`
    })};
	${({ theme  })=>theme.media.down('tablet')} {
		border-bottom: 0;
	}

	flex-grow: 1;
	padding: 12px 12px 16px;
	position: relative;
	${FlexMixin()}

	&.included-taxes {
		${FlexMixin({
    direction: 'column'
})}
		border-bottom: 1px solid ${({ theme  })=>theme.colors.status.highlighted};

		::after {
			background-color: ${({ theme  })=>theme.colors.white.base};
			border-bottom: 1px solid ${({ theme  })=>theme.colors.status.highlighted};
			border-right: 1px solid ${({ theme  })=>theme.colors.status.highlighted};
			bottom: -5px;
			content: '';
			height: 8px;
			position: absolute;
			right: 20px;
			transform: rotate(45deg);
			width: 8px;
		}
	}

	${({ theme  })=>productCardDesktopThemes[theme.id]?.ProductCardBody?.()}
`;
export const CardProductLiteralTaxes = styled.div.withConfig({
    displayName: "styled__CardProductLiteralTaxes",
    componentId: "sc-2abbd9bc-1"
})`
	${FlexMixin({
    justify: 'flex-end',
    align: 'flex-end'
})}
	flex-grow: 1;
	margin-top: 8px;
	width: 100%;

	& > p {
		${FlexMixin({
    wrap: true
})}
		${FontMixin({
    size: 'medium',
    height: 'smaller',
    weight: 'medium'
})}
		color: ${({ theme  })=>theme.colors.status.highlighted};
	}
`;
export const ProductCardFooter = styled.footer.withConfig({
    displayName: "styled__ProductCardFooter",
    componentId: "sc-2abbd9bc-2"
})`
	padding: 12px;
	${FlexMixin({
    align: 'stretch',
    justify: 'space-between'
})}
`;
export const ProductCardBox = styled.a.withConfig({
    displayName: "styled__ProductCardBox",
    componentId: "sc-2abbd9bc-3"
})`
	display: block;
	position: relative;
	height: 100%;
	min-width: 225px;
	width: 100%;
	padding: 2px;
	cursor: pointer;

	${({ $isTransportsNewCard  })=>$isTransportsNewCard && css`
			${ProductCardBody} {
				border-bottom: 0;
				padding-bottom: 0;
			}
			${ProductCardFooter} {
				padding-top: 0;
				padding-bottom: 8px;
			}
		`}

	@media (max-width: ${(props)=>props.theme.breakpoints.xxl}px) {
		min-width: 260px;
	}
	@media (max-width: ${(props)=>props.theme.breakpoints.xl}px) {
		min-width: 190px;
	}
	@media (max-width: ${(props)=>props.theme.breakpoints.lg}px) {
		min-width: 196px;
	}

	&.is-sold-out {
		overflow: hidden;
		pointer-events: none;

		&::before {
			${BorderRadius({
    all: '4px'
})}
			background-color: ${({ theme  })=>theme.colors.black.lower};
			content: '';
			height: 100%;
			left: 0;
			position: absolute;
			top: 0;
			width: 100%;
			z-index: ${({ theme  })=>theme.zIndex.low};
		}

		&::after {
			${FontMixin({
    size: 'xxl',
    weight: 'semiBold',
    height: 'xl'
})}
			background: ${({ theme  })=>theme.colors.black.base};
			border: 4px solid ${({ theme  })=>theme.colors.secondary.base};
			color: ${({ theme  })=>theme.colors.white.base};
			content: 'sold out!';
			font-family: ${({ theme  })=>theme.font.family.secondary};
			left: 50%;
			padding: 12px 28px;
			position: absolute;
			text-align: center;
			text-transform: uppercase;
			top: 24%;
			transform: rotate(-10deg) translateX(-50%);
			width: 120%;
			z-index: ${({ theme  })=>theme.zIndex.base};
		}
	}
`;
export const ProductCardWrapper = styled.article.withConfig({
    displayName: "styled__ProductCardWrapper",
    componentId: "sc-2abbd9bc-4"
})`
	${BoxShadowWithHover}
	${FlexMixin({
    direction: 'column'
})}
	overflow: hidden;
	${BorderRadius({
    all: '4px'
})}
	min-height: 100%;
	background-color: ${({ theme  })=>theme.colors.white.base};
`;
export const ProductCardHeader = styled.header.withConfig({
    displayName: "styled__ProductCardHeader",
    componentId: "sc-2abbd9bc-5"
})`
	max-height: 205px;
	overflow: hidden;

	img {
		height: auto;
		min-height: 145px;
		object-fit: fill;
		width: 100%;

		@media (max-width: ${(props)=>props.theme.breakpoints.lg}px) {
			object-fit: cover;
		}
	}
`;
export const ProductCardTitle = styled.h3.withConfig({
    displayName: "styled__ProductCardTitle",
    componentId: "sc-2abbd9bc-6"
})`
	${FlexMixin({
    align: 'baseline'
})};
	column-gap: 4px;
	color: ${({ theme  })=>theme.colors.primary.light};
	${FontMixin({
    size: 'large',
    height: 'large',
    weight: 'medium'
})};

	${({ theme  })=>theme.media.down('tablet')} {
		line-height: 26px;
	}
	margin-bottom: 4px;
	i {
		margin-right: 2px;
	}

	${({ theme  })=>productCardDesktopThemes[theme.id]?.ProductCardTitle?.()}
`;
export const Subtitle = styled.div.withConfig({
    displayName: "styled__Subtitle",
    componentId: "sc-2abbd9bc-7"
})`
	${FlexMixin({
    align: 'baseline'
})}
	column-gap: 4px;
	color: ${({ theme  })=>theme.colors.primary.lighter};
	${FontMixin({
    size: 'base',
    height: 'base',
    weight: 'regular'
})};
	margin-bottom: 8px;

	${({ theme  })=>theme.media.down('tablet')} {
		font-size: 14px;
		line-height: 20px;
		color: ${({ theme  })=>theme.colors.grays.darker};
	}

	${({ theme  })=>productCardDesktopThemes[theme.id]?.Subtitle?.()};
`;
export const Detail = styled(InnerMarkdownHTML).withConfig({
    displayName: "styled__Detail",
    componentId: "sc-2abbd9bc-8"
})`
	${FontMixin({
    size: 'medium',
    height: 'small',
    weight: 'light'
})};
	color: ${({ theme  })=>theme.colors.grays.dark};
	margin-bottom: 8px;
`;
export const Description = styled.div.withConfig({
    displayName: "styled__Description",
    componentId: "sc-2abbd9bc-9"
})`
	color: ${({ theme  })=>theme.colors.text.light};
	${FontMixin({
    size: 'medium',
    height: 'base',
    weight: 'light'
})};

	${({ theme  })=>theme.media.down('tablet')} {
		font-size: 12px;
		line-height: 18px;
	}

	p {
		margin-bottom: 2px;
	}
`;
export const Upside = styled.div.withConfig({
    displayName: "styled__Upside",
    componentId: "sc-2abbd9bc-10"
})`
	color: ${({ theme  })=>theme.colors.primary.lighter};
	${FontMixin({
    size: 'medium',
    height: 'base',
    weight: 'bold'
})}

	${({ theme  })=>theme.media.down('tablet')} {
		line-height: 20px;
		font-weight: 500;
	}

	p {
		margin-bottom: 2px;
	}

	${({ theme  })=>productCardDesktopThemes[theme.id]?.Upside?.()}
`;
export const ProductCardIconProps = styled.div.withConfig({
    displayName: "styled__ProductCardIconProps",
    componentId: "sc-2abbd9bc-11"
})`
	color: ${({ theme  })=>theme.colors.grays.base};
	font-size: 28px;
	${FontMixin({
    height: 'base',
    weight: 'medium'
})}
	${FlexMixin({
    align: 'center'
})}

	${Icon} {
		&:not(:last-child) {
			margin-right: 8px;
		}
	}

	${({ theme  })=>theme.media.down('tablet')} {
		${FontMixin({
    size: 'larger'
})};
	}
`;
export const Company = styled(Image).withConfig({
    displayName: "styled__Company",
    componentId: "sc-2abbd9bc-12"
})`
	max-width: 60px;
	min-width: 60px;
	padding-right: 8px;
	margin-right: 8px;
	border-right: 1px solid ${({ theme  })=>theme.colors.grays.lighter};
	${FlexMixin({
    align: 'center'
})}
`;
export const Summary = styled.div.withConfig({
    displayName: "styled__Summary",
    componentId: "sc-2abbd9bc-13"
})`
	display: block;
	visibility: hidden;
	margin-right: -100%;
	width: 100%;
	max-height: 333px;
	overflow-y: auto;
	&::-webkit-scrollbar {
		width: 6px;
		background-color: ${({ theme  })=>theme.colors.grays.light};
	}

	&::-webkit-scrollbar-track {
		border-radius: 4px;
		background-color: ${({ theme  })=>theme.colors.grays.light};
	}

	&::-webkit-scrollbar-thumb {
		border-radius: 3px;
		background-color: ${({ theme  })=>theme.colors.grays.base};
	}

	&.is-active {
		visibility: visible;
	}

	${Stars} {
		${FontMixin({
    size: 'medium',
    height: 'base',
    weight: 'regular'
})};

		${({ theme  })=>theme.media.down('tablet')} {
			font-size: 12px;
			line-height: 12px;
		}
	}

	display: flex;
	flex-direction: column;
`;
export const MoreInfo = styled.div.withConfig({
    displayName: "styled__MoreInfo",
    componentId: "sc-2abbd9bc-14"
})`
	color: ${({ theme  })=>theme.colors.grays.darker};
	${FontMixin({
    size: 'medium',
    height: 'base',
    weight: 'light'
})}

	display: block;
	visibility: hidden;
	margin-right: -100%;
	width: 100%;
	max-height: 333px;
	overflow-y: auto;
	&::-webkit-scrollbar {
		width: 6px;
		background-color: ${({ theme  })=>theme.colors.grays.light};
	}

	&::-webkit-scrollbar-track {
		border-radius: 10px;
		background-color: ${({ theme  })=>theme.colors.grays.light};
	}

	&::-webkit-scrollbar-thumb {
		border-radius: 3px;
		background-color: ${({ theme  })=>theme.colors.grays.base};
	}

	&.is-active {
		visibility: visible;
	}

	& span::after {
		content: ' ';
	}
`;
export const Tripadvisor = styled(Image).withConfig({
    displayName: "styled__Tripadvisor",
    componentId: "sc-2abbd9bc-15"
})`
	width: 120px;
	height: 20px;
	margin-bottom: 8px;
	margin-left: -8px;
`;
export const Reviews = styled.span.withConfig({
    displayName: "styled__Reviews",
    componentId: "sc-2abbd9bc-16"
})`
	${FlexMixin({
    align: 'center'
})}
	${FontMixin({
    size: 'medium',
    weight: 'regular',
    height: 'base'
})}
	color: ${({ theme  })=>theme.colors.status.success};
	margin-bottom: 4px;

	${Icon} {
		margin: 0 4px 4px 4px;
	}

	&.reviews-veryGood {
		color: ${({ theme  })=>theme.colors.primary.lighter};
	}
`;
export const Promotion = styled.div.withConfig({
    displayName: "styled__Promotion",
    componentId: "sc-2abbd9bc-17"
})`
	color: ${({ theme  })=>theme.colors.status.offer};
	${FontMixin({
    size: 'medium',
    weight: 'bold',
    height: 'base'
})}
	margin-bottom: 4px;
	${({ theme  })=>productCardDesktopThemes[theme.id]?.Promotion?.()}
`;
export const Transport = styled.div.withConfig({
    displayName: "styled__Transport",
    componentId: "sc-2abbd9bc-18"
})`
	color: ${({ theme  })=>theme.colors.status.success};
	${FontMixin({
    size: 'medium',
    weight: 'medium',
    height: 'base'
})}
	margin-bottom: 8px;
`;
export const NewProductCardFooter = styled.div.withConfig({
    displayName: "styled__NewProductCardFooter",
    componentId: "sc-2abbd9bc-19"
})`
	${FlexMixin({
    justify: 'space-between',
    align: 'center'
})}
	width: 100%;
	.nico-info {
		${FontMixin({
    size: 'larger'
})}
	}
`;

//# sourceMappingURL=styled.js.map